<script lang="ts" setup>
interface SortOption {
  key: string
  label: string
  [key: string]: unknown
}

defineProps<{
  totalCount?: number
  currentPage?: number
  totalPages?: number
  itemsPerPage?: number
  itemsPerPageOptions?: number[]
  sort?: string
  sortOptions?: SortOption[]
  view?: 'grid' | 'list'
  surroundActivePage?: 2
}>()

const emit = defineEmits(['updateView', 'updateItemsPerPage', 'updateSort', 'updatePage'])
</script>

<template>
  <div class="paginator">
    <slot name="before" />
    <PaginatorView
      v-if="view"
      :view="view"
      class="paginator__view"
      @update-view="(value) => emit('updateView', value)"
    />
    <PaginatorTotalCount
      v-if="totalCount"
      :total-count="totalCount"
      class="paginator__total"
    />
    <PaginatorSort
      v-if="sort && sortOptions?.length && sortOptions.length > 1"
      class="paginator__sort"
      :sort="sort"
      :sort-options="sortOptions"
      @update-sort="(value) => emit('updateSort', value)"
    />
    <PaginatorItemsPerPage
      v-if="itemsPerPage && itemsPerPageOptions?.length && itemsPerPageOptions.length > 1"
      class="paginator__items-per-page"
      :items-per-page="itemsPerPage"
      :items-per-page-options="itemsPerPageOptions"
      @update-items-per-page="(value) => $emit('updateItemsPerPage', value)"
    />
    <PaginatorPages
      v-if="currentPage && totalPages && totalPages > 1"
      :current-page="currentPage"
      :total-pages="totalPages"
      class="paginator__pages"
      @update-page="(value) => emit('updatePage', value)"
    />
    <slot name="after" />
  </div>
</template>

<style>
@import url("~layers/components/Paginator/Toolbar.css");
</style>
